module.exports = __webpack_public_path__ + "static/img/end.cde051d2.svg";